<template>

  <!--
    
    prop(인자값 설명)
    gridColumn : 헤더 값
          => 필수 key : field,header
             선택 key : type(edit기능을 사용 시 무슨 타입으로 변경할지 적어줘야함 text,date,select),cdgr(edit에서 select일때 공통코드 그룹코드를 넘겨줘야함),style 

    dataList : 그리드 row data
    editable : edit 기능 사용여부 => true로 줄때 gridColumn 인자값에 type을 명시해줘야함 없으면 읽기모드

    emits(부모페이지 return)
    editCol : 셀 클릭 시 어디를 타겟해서 edit모드로 변경할지 부모페이지에 넘김 -> dataList에 editCell 수정(참고 MIM_CL_001 > editCell)
    editComplete : edit 완료 시 변경값을 부모페이지에 넘김

    edit 기능 구현은 MIM_CL_001화면 참고
  -->
  <TreeTable
    ref="treeTabelRef"
    :value="dataList"
    :paginator="props.paginator"
    :rows="20"
    :rowsPerPageOptions="[10, 20, 50, 100, 200]"
    scrollable
    scrollDirection="both"
    v-model:selectionKeys="selectionKeys" 
    :selectionMode="props.selectType"
  > 
    <template #empty>
        <div class="center">데이터가 존재하지 않습니다.</div>
    </template>

    <Column style="width: 40px" v-if="props.useCheckBox">
      <template #header>
        <ElCheckbox v-model="allCheck" :disabled="props.disabledCheckBox"/>
      </template>
      <template #body="slotProps">
        <ElCheckbox 
          v-model="selectRows" 
          :value="slotProps.node.key"
          :disabled="props.disabledCheckBox"
        />
      </template>
    </Column>
    <Column
      v-for="item of props.gridColumn"
      :field="item.field"
      :header="item.header"
      :key="item.field"
      :expander="item.expander"
      :style="item.style"
      :bodyClass="item.bodyClass"
      :headerClass="item.bodyClass" 
    >

      <!-- 수정 가능 -->

      <template #body="slotProps">
          <ElInput 
            v-if="checkEditable(slotProps,'text')" 
            v-model="slotProps.node.data[slotProps.column.key]" 
            :focusYn="true"  
            @inputKeyupEnter="r=>r.target.blur()"
            @inputBlur="onCellEditComplete(slotProps)"
          />
          <SelectCode
            v-else-if="checkEditable(slotProps,'select')"
            ref="selectByCodeRef"
            :cd_gr="item.cdGr"
            :chk_ess="item.chkEss"
            :matchCd="returnData(slotProps)"
            @return="r=>updateCdVal(slotProps,r)"
          />
          <DatePicker
            v-else-if="checkEditable(slotProps,'date')"
            :selectDate="returnData(slotProps)"
            @return="r=>updateDate(slotProps,r)"
          />
          <div class="blank-div" @click="cellEdit(slotProps)" v-else>
            <span >{{ returnData(slotProps) }}</span>
          </div>
              
        </template>

          <!--그 외 경우 읽기모드-->

    </Column>
  </TreeTable>
</template>

<script setup>
import {  computed, reactive, ref } from "vue";
import TreeTable from "primevue/treetable";
import Column from "primevue/column";
import DatePicker from "./DatePicker.vue";
import SelectCode from "./SelectCode.vue";
const refInput = ref()
const selectByCodeRef = ref()
const treeTabelRef = ref()
const props = defineProps({
  gridColumn : {
    type : Array,
    default : []
  },
  dataList : {
    type : Array,
    default : []
  },
  editable : {
    type : Boolean,
    default : false
  },
  rootVal : {
    type : String,
    default : ''
  },
  useCheckBox : {
    type : Boolean,
    default : false
  },
  selectType : {
    type : String,
    default : ''
  },
  disabledCheckBox : {
    type : Boolean,
    default : false
  },
  paginator : {
    type : Boolean,
    default : false
  }
})
const emits = defineEmits(['editCol','editComplete'])


let selectRows = ref([])
let selectionKeys = ref(null)
let parentKey;
let key;
const state = reactive({
  prodSelectedRow : null
})
//checkbox
const allCheck = computed({
  get() {
    return props.dataList.length === selectRows.value.length;
  },
  set(newValue) {
    selectRows.value = newValue
      ? props.dataList.map((item) => {
          return item[key];
        })
      : [];
  },
});

//1차원 배열 다차원 배열변환
const dataList = computed(()=>{
  try{
    [ parentKey ] = Array.from(new Set(props.dataList.map(item => Object.keys(item).find(key => key.includes('up_')))))
    if(!parentKey) return

    key = parentKey.split('up_').join('')
    const rootList = []

    props.dataList.filter(item => item[parentKey] === props.rootVal).forEach((parentItem,index)=>{
      let row = {
        expendKey : index,
        key: parentItem[key],
        data: parentItem,
        editCell: parentItem.editCell ? {...parentItem.editCell} : {},
      };
      rootList.push(row);
    })
    rearrange(rootList)
    return rootList
  }catch(e){
    console.log(e)
    return []
  }
 
})

//child depth 계속 생성
const rearrange = (rootList) => {
  try{
    rootList.forEach((item)=>{
      let childTree = [];
      props.dataList.forEach((i) => {
        if (i[parentKey] == item.key) {
          let row = {
            key: i[key],
            data: i,
            editCell: i.editCell ? {...i.editCell} : {},
          };
          childTree.push(row);
        }
      });

      if (childTree?.length > 0) {
        item.children = childTree;
        rearrange(childTree);
      }
    })
  }catch(e){
    console.log(e)
    return rootList
  }

    
};


//셀 클릭시 edit모드 활성화
const cellEdit = (slotProps) => {
  try{
    slotProps.node.editCell[slotProps.column.key] = true
    let editData = {
      key : slotProps.node.key,
      col : slotProps.column.key
    }
    emits('editCol',editData)
  }catch(e){
    console.log(e)
  }

}

//edit 컬럼 찾기
const checkEditable = (slotProps,colType) => {
  try{
    //클래스명,사용여부,메모 컬럼만 수정 가능함
    if (props.editable &&slotProps.node.editCell[slotProps.column.key] === true) {
      let flag = false

      props.gridColumn.forEach((item)=>{
        if(item.field === slotProps.column.key){
          if(item.type === colType){
            flag = true
          } 
        }
      })

      if(flag){
        //자동 focus
        if (refInput.value?.length > 0) {
          refInput.value[0].focus();
        }
        else if(selectByCodeRef.value?.length > 0){
          selectByCodeRef.value[0].focus();
        }
        return true;
      }

    }

    return false;
  }catch(e){
    console.log(e)
  }

};

//row 데이터 읽기
const returnData = (slotProps) =>{
  try{
    return slotProps.node.data[slotProps.column.key] ? slotProps.node.data[slotProps.column.key] : ''
  }catch(e){
    console.log(e)
    return ''
  }
}

//셀수정 완료
const onCellEditComplete = (slotProps) =>{
  emits('editComplete',slotProps)
}

//코드 select 공통 컴포넌트 값 변경시
const updateCdVal = (slotProps,val)=>{
  slotProps.node.data[slotProps.column.key] = val.cd_id
  onCellEditComplete(slotProps)
}

//date update
const updateDate = (slotProps,val)=>{
  slotProps.node.data[slotProps.column.key] = val
  onCellEditComplete(slotProps)
}




defineExpose({
  selectRows,
  selectionKeys
});
</script>